// check if url is a file
export const checkIsFile = (path) => {

	var isFile = false;

	if(path && path?.length > 0){

		const split = path?.split('/');
	    const filename = split.pop(); 

	    if(filename && filename?.length > 0){

	    	const splitExtension = filename?.split('.');

	    	// if there is extension
	    	if(splitExtension && splitExtension?.length > 1){
	    		isFile = true;
	    	}
	    }
	}

	return isFile;
}

// get file type from mime
export const getFileType = (mime) => {

	var type = 'file';

	if(mime && mime?.length > 0){

		const split = mime?.split('/');

	    const category = split[0]; 

	    if(category && category?.length > 0){

		    switch(category){

		    	case 'application':
		    		
		    		var subtype = split.pop();
		    		switch(subtype){

		    			case 'pdf':
		    				type = 'pdf';
		    				break;

		    			case 'vnd.ms-excel.sheet.macroenabled.12':
		    				type = 'excel';
		    				break;

		    			default:
		    				type = 'file';
		    				break;
		    		}
		    		break;

		    	default:
		    		type = category;
		    		break;
		    }
		}
	}
    
    return type;
}

// get file type from name
export const getFileInfoFromFilePath = (t,path) => {

	var type = 'file';
	var mime = '';	

	if(path && path?.length > 0){

		const split = path?.split('/');
	    const filename = split.pop(); 

	    if(filename && filename?.length > 0){

	    	const splitExtension = filename?.split('.');

	    	// if there is extension
	    	if(splitExtension && splitExtension?.length > 1){

	    		const extension = splitExtension?.pop()?.toLowerCase();	    		

			    switch(extension){

			    	case 'ico':
			    		type = 'image';		
			    		mime = 'image/x-icon';
			    		break;

			    	case 'png':
			    		type = 'image';		
			    		mime = 'image/png';
			    		break;

			    	case 'jpeg':
			    	case 'jpg':
			    		type = 'image';		
			    		mime = 'image/jpeg';
			    		break;

			    	case 'bmp':
			    		type = 'image';		
			    		mime = 'image/bmp';
			    		break;

			    	case 'tiff':
			    		type = 'image';			    		
			    		mime = 'image/tiff';
			    		break;

			    	case 'pdf':
			    		type = 'pdf';
			    		mime = 'application/pdf';
			    		break;
			    }
			}
		}
	}

	var name = t('types.'+type);
    
    return {type,mime,name};
}         

// to format file size
export const formatBytes = (bytes, decimals = 2) => {
	
	if(bytes === 0){
		return '0Bytes';
	}

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + '' + sizes[i];
}